import { StatusTag } from '@pos/admin-ui';
import type { StoreConnectionDto } from '@pos/api-client';
import { useTranslation, type I18nKey } from '@pos/i18n';

// The pairing status codes as the shared StatusTag colours them (green done, blue in progress, red failed, gray none).
const STATUS_TONE: Record<string, string> = {
  paired: 'active',
  pairing: 'pending',
  revoked: 'failed',
  not_paired: 'new',
};

/** Pairing status, and whether a paired store is online (a heartbeat in the last few minutes). */
export function ConnectionStatus({ connection }: { connection: Pick<StoreConnectionDto, 'status' | 'online'> }) {
  const { t } = useTranslation();
  return (
    <span className="pos-sync-status">
      <StatusTag status={STATUS_TONE[connection.status] ?? connection.status}>
        {t(`admin.sync.status.${connection.status}` as I18nKey, { defaultValue: connection.status })}
      </StatusTag>
      {connection.status === 'paired' && (
        <StatusTag status={connection.online ? 'active' : 'new'}>
          {connection.online ? t('admin.sync.online') : t('admin.sync.offline')}
        </StatusTag>
      )}
    </span>
  );
}
